import {
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { Controller, Control, FieldValues } from "react-hook-form";
// import { Controller, Control, FieldValues, useFormContext, useForm } from "react-hook-form";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

interface PropType {
  name: string;
  control: Control<FieldValues, any>;
  placeholder?: string;
  type?: string;
  rules?: {};
  fullWidth?: boolean;
  disabled?: boolean;
  inputProps?: any;
  size?: "small" | "medium" | undefined;
  showeyeIcon?: boolean;
  eyeIconStatus?: boolean;
  handleIcon?: () => void;
  onKeyPress?: (e: any) => void;
  inputValue?: any;
  // setFromToData?:any
}

const Text = (props: PropType) => {
  const {
    name,
    control,
    placeholder,
    type,
    rules,
    fullWidth,
    disabled,
    inputProps,
    size = undefined,
    showeyeIcon = false,
    eyeIconStatus = false,
    handleIcon,
    onKeyPress,
    inputValue,
    //setFromToData
  } = props;
  return (
    <Box>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({
          field: { onChange, value },
          // field: { onChange, value ,name,...field},
          formState,
          fieldState: { error },
        }) => {
          return (
            <>
              <TextField
                //  {...field}
                //  name={name}
                // onSubmit={}
                // value={value}
                value={
                  inputValue?.length > 0
                    ? name == "new_password" || name == "confirm_password"
                      ? String(inputValue).trim()
                      : inputValue
                    : (name == "new_password" || name == "confirm_password") &&
                      value
                    ? String(value).trim()
                    : value
                }
                onChange={onChange}
                placeholder={placeholder && placeholder}
                type={type && type}
                fullWidth={fullWidth}
                disabled={disabled}
                sx={{
                  backgroundColor: "#FFF",
                  border: error ? "1px solid red" : "inherit",
                  width: "100%",
                }}
                inputProps={inputProps}
                size={size}
                onKeyPress={onKeyPress}
                InputProps={{
                  endAdornment: (
                    <>
                      {showeyeIcon && (
                        <InputAdornment position="end">
                          {eyeIconStatus ? (
                            <IconButton onClick={handleIcon && handleIcon}>
                              <Visibility />
                            </IconButton>
                          ) : (
                            <IconButton onClick={handleIcon && handleIcon}>
                              <VisibilityOff />
                            </IconButton>
                          )}
                        </InputAdornment>
                      )}
                    </>
                  ),
                }}
              />
              {error ? (
                <>
                  <Typography
                    sx={{
                      color: "#F05252",
                      position: "absolute",
                      width: { xs: "50%", lg: "100%" },
                    }}
                    // sx={{ color: "#F05252", position: "absolute" ,  width: "100%",}}
                    fontSize="12px"
                  >
                    {error.message}
                  </Typography>
                  <Box padding={0.5} />
                </>
              ) : null}
            </>
          );
        }}
      />
    </Box>
  );
};

export default Text;
